import { themeColor } from '@config/theme';
import { Button } from '@mui/material';

interface CardProps {
	title: string;
	subTitle?: string;
	children: React.ReactNode;
	buttonBgColor: string;
	buttonText: string;
	icon?: React.ReactNode;
	onClick?: () => void;
}

const buttonStyles = (buttonBgColor: string) => ({
	color: themeColor.contrastTextWhite,
	fontFamily: 'Roboto, sans-serif',
	fontSize: '14px',
	fontWeight: 'bold',
	lineHeight: '140%',
	textTransform: 'uppercase',
	height: '42px',
	paddingY: '10px',
	paddingX: '20px',
	borderRadius: '8px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '10px',
	backgroundColor: buttonBgColor,
});

export const SettingsCard: React.FC<CardProps> = ({
	title,
	subTitle,
	children,
	buttonBgColor,
	buttonText,
	icon,
	onClick,
}) => {
	return (
		<div className="flex flex-col gap-5 justify-between rounded-[15px] bg-white shadow-custom-button p-5 h-full">
			<div className="flex flex-col gap-5">
				<h2 className="text-[20px] roboto-bold leading-[140%]">{title}</h2>
				{subTitle && <h5 className="text-secondary roboto-regular leading-[140%]">{subTitle}</h5>}
				<div className="flex flex-col gap-[20px] pb-5">{children}</div>
			</div>
			<Button sx={buttonStyles(buttonBgColor)} type="button" onClick={onClick}>
				{icon}
				{buttonText}
			</Button>
		</div>
	);
};
